import { Http, Headers, Response, RequestOptions } from '@angular/http';
import { Observable } from 'rxjs/Observable';

import { BodyService} from "../../shared/utils/body.service";

export class BaseService {
    
    protected options = this.bodyService.jwt();
    protected rutaServidor = localStorage.getItem('rutaServidor');

    constructor(protected http: Http,
                protected bodyService: BodyService) { 
    }

 
   

 }


// WEBPACK FOOTER //
// ./src/app/shared/utils/BaseService.ts